import WashdayClientSingleton from './WashdayClientSingleton';

export const getCashupReportListV2 = async (storeId: string, params: {
  pageNum: string;
  limit: string;
  cashierBoxId?: string;
}) => {
  try {
    return await WashdayClientSingleton.getInstance().cashup.getList(storeId, params);
  } catch (e) {
    console.log('ERROR getCashupReportListV2', e);
    throw e;
  }
};


export const getCashupReportByIdV2 = async (storeId: string, id: string) => {
  try {
    return await WashdayClientSingleton.getInstance().cashup.getById(storeId, id);
  } catch (e) {
    console.log('ERROR getCashupReportByIdV2', e);
    throw e;
  }
};

export interface DeleteCashupReportPayload {
  cancellationReason?: string | null;
}

export const deleteCashupReportByIdV2 = async (
  storeId: string,
  id: string,
  data?: DeleteCashupReportPayload
) => {
  try {
    return await WashdayClientSingleton.getInstance().cashup.deleteCashUpReport(storeId, id, data);
  } catch (e) {
    console.log('ERROR deleteCashupReportByIdV2', e);
    throw e;
  }
};

export const getPreviewDataForCashClose = async (storeId: string, id: string) => {
  try {
    return await WashdayClientSingleton.getInstance().cashup.getPreviewDataForCashClose(storeId, id);
  } catch (e) {
    console.log('ERROR getPreviewDataForCashClose', e);
    throw e;
  }
};

export const createCashupReportV2 = async (storeId: string, id: string, data: {
  cashierBox: string;
  startingCash: number;
  declaredCash: number;
  declaredCard: number;
  declaredTransfer: number;
  declaredMercadoPago: number;
  cashToBank: number;
  notes: string;
}) => {
  try {
    return await WashdayClientSingleton.getInstance().cashup.create(storeId, id, data);
  } catch (e) {
    console.log('ERROR createCashupReportV2', e);
    throw e;
  }
};
